import { useCallback } from "react";
import { useLocalAppConfig } from "../../hooks/use-local-app-config";
import "./LocalAppConfig.scss";

const LocalAppConfig = () => {
  const {
    plan,
    accessToken,
    geminiApiKey,
    setAccessToken,
    setGeminiApiKey,
    licenseKey,
    setLicenseKey,
  } = useLocalAppConfig();

  const handleClearCalendarAccess = useCallback(() => {
    setAccessToken(null);
  }, [setAccessToken]);

  if (!accessToken) {
    return null;
  }

  return (
    <div className="local-app-config-container">
      <div className="header">Configuration</div>

      <div className="plan-info">
        <span className="prefix">Plan</span>
        <span className="plan-name">{plan}</span>
      </div>
      <hr />
      <button className="btn btn-primary" onClick={handleClearCalendarAccess}>
        Remove Google Calendar Access
      </button>
      <div className="form-group">
        <label htmlFor="gemini-api-key">Gemini API Key</label>
        <input
          type="text"
          id="gemini-api-key"
          className="form-control"
          value={geminiApiKey ?? ""}
          placeholder="Enter your Gemini API key"
          onChange={(e) => setGeminiApiKey(e.target.value)}
        />
        <div className="form-text">
          Your Gemini API key is used to answer questions about your calendar.
        </div>
      </div>
      <div className="form-group">
        <label htmlFor="license-key">License Key</label>
        <input
          type="text"
          id="license-key"
          className="form-control"
          value={licenseKey ?? ""}
          placeholder="Enter your license key"
          onChange={(e) => setLicenseKey(e.target.value)}
        />
        <div className="form-text">
          Your license key is used to unlock the full features of the app.
        </div>
      </div>
    </div>
  );
};

export default LocalAppConfig;
